import React from 'react'
import s from './styles.module.css'

interface ProgressIndicatorProps {
  currentQuestionIndex: number
  totalQuestions: number
  overrideCurrentIndex?: number
  overrideTotalQuestions?: number
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentQuestionIndex,
  totalQuestions,
  overrideCurrentIndex,
  overrideTotalQuestions,
}) => {
  const displayIndex = overrideCurrentIndex ?? currentQuestionIndex
  const displayTotal = overrideTotalQuestions ?? totalQuestions
  const progress = displayTotal > 0 ? (displayIndex + 1) / displayTotal : 0

  return (
    <div className={s.container}>
      {/* <div className={s.text}>
        Question {currentQuestionIndex + 1} of {totalQuestions}
      </div> */}
      <div className={s.progressBarBackground}>
        <div
          className={s.progressBarFill}
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressIndicator
